var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2666 0.906284C12.2666 0.537803 12.0435 0.206007 11.7022 0.0669999C11.361 -0.0720188 10.9696 0.00942316 10.7121 0.273021L9.80526 1.20137C7.24275 0.0223766 4.12707 0.511027 2.02753 2.66035C-0.675845 5.4278 -0.675845 9.90624 2.02753 12.6737C4.74247 15.453 9.15337 15.453 11.8683 12.6737C13.4432 11.0614 14.0974 8.8713 13.8421 6.78427C13.7813 6.28752 13.3294 5.93397 12.8325 5.99475C12.3358 6.05552 11.9822 6.50756 12.043 7.00431C12.2352 8.57599 11.741 10.2101 10.5717 11.4071C8.56793 13.4585 5.3279 13.4585 3.32409 11.4071C1.30864 9.34388 1.30864 5.99015 3.32409 3.92688C4.70851 2.50959 6.68148 2.07265 8.42813 2.61111L7.50798 3.55305C7.25326 3.81388 7.17955 4.20199 7.32105 4.53803C7.46255 4.87406 7.7917 5.09257 8.15625 5.09257H11.3604C11.8609 5.09257 12.2666 4.68683 12.2666 4.18632V0.906284Z",
    fill: "#4C3A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshLogo);
export default __webpack_public_path__ + "static/media/refreshLogo.d896580e483ede8578d2e7e33a1275f7.svg";
export { ForwardRef as ReactComponent };